import {create} from 'zustand';

const useStore = create((set) => ({
  unit: 'ft',
  wallWidth: 5,
  wallHeight: 5,
  maxLEDWidth: '',
  maxLEDHeight: '',
  ledModel: '0.625',
  email: '',
  name: '',
  phone: '',
  companyName: '',
  projectName: '',
  orderNumber: '',
  budget: '',
  bid: '',
  estimateInstallDate: '',
  projectApplication: '',
  mount: '',
  onsiteCommissioningRequired: '',
  warrantyRequirement: '',
  inputResolution: '',
  quantityOfInputs: '',
  trimRequired: '',

  setUnit: (unit) => set(() => ({ unit })),

  setWallWidth: (wallWidth) => set(() => ({ wallWidth })),
  setWallHeight: (wallHeight) => set(() => ({ wallHeight })),
  
  setMaxLEDWidth: (maxLEDWidth) => set(() => ({ maxLEDWidth })),
  setMaxLEDHeight: (maxLEDHeight) => set(() => ({ maxLEDHeight })),

  setLedModel: (ledModel) => set(() => ({ ledModel })),

  setemail: (email) => set(() => ({ email })),
  setname: (name) => set(() => ({ name })),
  setphone: (phone) => set (() => ({ phone })),
  setcompanyname: (companyName) => set (() => ({ companyName })),

  setProjectName: (projectName) => set(() => ({ projectName })),
  setOrderNumber: (orderNumber) => set(() => ({ orderNumber })),

  setBudget: (budget) => set(() => ({ budget })),
  setBid: (bid) => set(() => ({ bid })),
  setProjectApplication: (projectApplication) => set(() => ({ projectApplication })),
  setEstimateInstallDate: (estimateInstallDate) => set(() => ({ estimateInstallDate })),
  setMount: (mount) => set(() => ({ mount })),
  setOnsiteCommissioningRequired: (onsiteCommissioningRequired) => set(() => ({ onsiteCommissioningRequired })),
  setWarrantyRequirement: (warrantyRequirement) => set(() => ({ warrantyRequirement })),
  setInputResolution: (inputResolution) => set(() => ({ inputResolution })),
  setQuantityOfInputs: (quantityOfInputs) => set(() => ({ quantityOfInputs })),
  setTrimRequired: (trimRequired) => set(() => ({ trimRequired })),


}));

export default useStore;
